import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.75} y={0.75} width={34.5} height={22.5} fill="white" />
      <path
        d="M15.8226 16.8586H13.4258L14.9249 8.1582H17.3216L15.8226 16.8586Z"
        fill="#1434CB"
      />
      <path
        d="M24.51 8.37041C24.0373 8.19437 23.2874 8 22.3603 8C19.9934 8 18.3266 9.18468 18.3164 10.8784C18.2967 12.128 19.5098 12.8221 20.417 13.2388C21.3443 13.6646 21.6595 13.9425 21.6595 14.322C21.65 14.9048 20.9102 15.1735 20.2201 15.1735C19.2632 15.1735 18.7505 15.035 17.9713 14.7107L17.6557 14.5717L17.3203 16.5248C17.8824 16.7651 18.9181 16.9785 19.9934 16.9878C22.5083 16.9878 24.1455 15.8215 24.1649 14.0165C24.1745 13.0261 23.534 12.2672 22.1531 11.647C21.3148 11.2489 20.8014 10.9805 20.8014 10.5732C20.8112 10.2029 21.2356 9.82364 22.1819 9.82364C22.9611 9.80507 23.5336 9.98086 23.9673 10.1568L24.1841 10.2492L24.51 8.37041V8.37041V8.37041Z"
        fill="#1434CB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8011 8.1582H30.655L32.5886 16.8585H30.3694C30.3694 16.8585 30.1523 15.8589 30.0835 15.5534H27.0062C26.9172 15.7847 26.5032 16.8585 26.5032 16.8585H23.9883L27.5484 8.88008C27.7951 8.31542 28.2294 8.1582 28.8011 8.1582ZM28.6532 11.3427C28.6532 11.3427 27.8937 13.2772 27.6963 13.777H29.6885C29.5899 13.342 29.136 11.2594 29.136 11.2594L28.9685 10.5098C28.898 10.7028 28.796 10.9682 28.7272 11.1472C28.6806 11.2686 28.6492 11.3502 28.6532 11.3427Z"
        fill="#1434CB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.03945 8.1582H6.89564C7.41833 8.17653 7.84245 8.33388 7.98047 8.88955L8.81876 12.8882C8.81868 12.888 8.81861 12.8878 8.81853 12.8876C8.81855 12.8877 8.81857 12.8877 8.8186 12.8878L9.07509 14.0911L11.4223 8.1582H13.9567L10.1894 16.8494H7.65487L5.51859 9.2894C4.78157 8.88498 3.94043 8.55972 3 8.334L3.03945 8.1582Z"
        fill="#1434CB"
      />
      <rect
        x={0.75}
        y={0.75}
        width={34.5}
        height={22.5}
        stroke="#CBD5E1"
        strokeWidth={1.5}
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-visa" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
